import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';

import { createCustomer2, createCustomer, customerCreated } from '../../actions/company';
import NavBarConfig from '../../components/NavBarConfig';
import CustomerCreate from './components/CustomerCreate';

const messages = defineMessages({
  BACK: {
    id: 'CustomerCreatePage.BACK',
    defaultMessage: 'Zurück',
  },
  APPLY_CUSTOMER: {
    id: 'CustomerCreatePage.APPLY_CUSTOMER',
    defaultMessage: 'Kunde anlegen',
  },
});

function CustomerCreatePage({
  company,
  companyMembership,
  onSubmit,
  routes,
  intl: { formatMessage },
}) {
  if (!company || !companyMembership) {
    return null;
  }
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig
        createPage
        currentRouteName={routes[routes.length - 1].name}
      />
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '700px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={`/company/${company.id}/customer/`} onMouseDown={e => e.preventDefault()} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.APPLY_CUSTOMER)}
            </h2>
          </div>
          
          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
            <CustomerCreate onSubmit={onSubmit} initialValues={{ locale: 'de' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, (dispatch, props) => ({
  onSubmit: formData =>
    createCustomer2(props.params.companyId, formData)
      .then(response => {
        if(response.error == null){
          const customer = response.response;
          //console.log('create customer');
          //console.log(customer);
          const url = `/company/${customer.company_id}/customer/${customer.id}/`;
          //console.log(url);
          dispatch(customerCreated(customer));
          dispatch(
            push(`/company/${customer.company_id}/customer/${customer.id}/`)
          );
        }
    }),
}))(injectIntl(CustomerCreatePage));
